// extracted by mini-css-extract-plugin
export default {"dealerSelectorDialogContainer":"_dealer-dealer-group-editor-dialog_dealerSelectorDialogContainer__9Z0z3"};